var _circle, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwiperLifestyleInactiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.5,112.45A14.029,14.029,0,1,1,230.53,98.421,14.045,14.045,0,0,1,216.5,112.45Zm0-27a12.971,12.971,0,1,0,12.971,12.971A12.986,12.986,0,0,0,216.5,85.45Z",
    transform: "translate(-199.502 -81.421)",
    fill: "#635c7c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.432 8.351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.844,107.07a1.746,1.746,0,0,1-.7-.147.645.645,0,0,1-.167-.108c-.276-.219-.756-.6-.574-1.154l1.535-5.025-3.965-.014a1.047,1.047,0,0,1-1.038-1.071,1.058,1.058,0,0,1,.214-.625c.787-.98,1.5-1.975,2.183-2.937s1.407-1.974,2.2-2.959c.764-.963,1.546-1.929,2.33-2.9a.637.637,0,0,1,.178-.153,1.558,1.558,0,0,1,1.52-.021.634.634,0,0,1,.118.081c.242.207.709.606.526,1.159l-1.514,4.622,3.994.014a1.732,1.732,0,0,1,1.075.489.913.913,0,0,1,.295.658c.011.2.019.355.019.559a.648.648,0,0,1-.133.394c-1.486,1.953-3.079,3.9-4.62,5.781l-.479.583c-.637.774-1.281,1.556-1.945,2.384a.653.653,0,0,1-.185.158A1.75,1.75,0,0,1,214.844,107.07Zm-.111-1.314a.433.433,0,0,0,.242,0c.634-.789,1.249-1.537,1.859-2.277l.429-.521c1.533-1.873,3.07-3.75,4.5-5.625,0-.053,0-.1-.006-.139a.706.706,0,0,0-.115-.053l-4.857-.017a.65.65,0,0,1-.615-.852l1.7-5.2,0,0a.262.262,0,0,0-.1.007c-.748.923-1.494,1.846-2.226,2.768-.77.959-1.475,1.947-2.156,2.9-.6.847-1.226,1.718-1.9,2.58l4.327.015a.651.651,0,0,1,.619.84l-1.7,5.576Zm6.9-8.623Zm.12-.153c0,.014,0,.028,0,.042Zm-3.785-6.187v0Z",
    transform: "translate(-209.933 -89.772)",
    fill: "#635c7c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiperLifestyleInactiveIcon);
export default __webpack_public_path__ + "static/media/swiper_lifestyle_inactive_icon.9e081d01.svg";
export { ForwardRef as ReactComponent };